// src/services/organizationService.ts
import { api } from './api';
import { AuthResponse } from './authService';

export interface RegisterOrganizationDto {
  orgName: string;
  adminName: string;
  email: string;
  password: string;
}

export interface RegisterOrganizationResponse extends AuthResponse {
  organization: { _id: string; name: string; slug: string };
}

// Returned instead of RegisterOrganizationResponse when REQUIRE_EMAIL_VERIFICATION
// is on (the default) — no tokens are issued until the admin verifies their email.
export interface RegisterEmailVerificationRequiredResponse {
  emailVerificationRequired: true;
  email: string;
  organization: { _id: string; name: string; slug: string };
  message: string;
}

export const organizationService = {
  // POST /api/organizations/register — public, creates the org + its first admin
  register: (dto: RegisterOrganizationDto) =>
    api.post<RegisterOrganizationResponse | RegisterEmailVerificationRequiredResponse>('/organizations/register', dto).then(r => r.data),
};
